

<div class="modalCntrl" *ngIf="showEditor">
    <div class="modal-header" *ngIf="config.titleBar.show">
        <h5 class="modal-title" id="exampleModalLabel">{{config.titleBar.text}}
        </h5>
        <button type="button" class="close" (click)="cancel()" *ngIf="config.cancelIcon.show">
            <i class="icon-close"></i>
        </button>
    </div>
    <div class="modal-body px-0 py-0">
        <div [froalaEditor]="options" [(froalaModel)]="element.content" ></div>
    </div>
    <div class="modal-footer" *ngIf="config.footer.show">
        <button type="button" *ngIf="config.footer.cancelBtn.show" class="btn btn-dark" (click)="cancel()">{{config.footer.cancelBtn.text}}</button>
        <button type="button" *ngIf="config.footer.saveBtn.show" (click)="save()" class="btn btn-primary">{{config.footer.saveBtn.text}}</button>
    </div>
</div>